import { InputRef } from 'antd';
import { MutableRefObject, useEffect, useRef } from 'react';


export const useFocusOnLoad = <T extends HTMLInputElement | InputRef> (isActive = true): MutableRefObject<T> => {

    const firstInputRef = useRef<T>();

    useEffect(() => {
        if (isActive && firstInputRef?.current ) (firstInputRef.current).focus();
    }, [isActive]);

    return firstInputRef;
};